module.exports = __webpack_public_path__ + "img/ppt.0684b0f3.svg";